import PasswordChanged from "./passwordChanged";
export default PasswordChanged;
